var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsMIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2283",
    "data-name": "Group 2283",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.284,
    height: 41.665,
    viewBox: "0 0 27.284 41.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 27.284,
    height: 41.665,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M271.668,400.857l-3.822-2.221c1.216.707,2.9.609,4.753-.462l3.822,2.221c-1.854,1.07-3.537,1.168-4.753.462",
    transform: "translate(-249.148 -370.378)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M247.9,156.25l.043,15.291c.012,4.233,3.02,5.945,6.7,3.818l.011,3.978c-5.593,3.229-10.159.627-10.177-5.8l-.043-15.291Z",
    transform: "translate(-227.371 -145.343)",
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M193.507,128.654l-3.822-2.221,3.462-2,3.822,2.221Z",
    transform: "translate(-176.444 -115.747)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M193.55,170.581l-.043-15.291-3.822-2.221.043,15.291c.009,3.192,1.14,5.44,2.962,6.5l3.822,2.221c-1.822-1.059-2.953-3.307-2.962-6.5",
    transform: "translate(-176.444 -142.384)",
    fill: "#ff8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M153.357,212.231l.071,24.956-3.28,1.894-.071-24.956Z",
    transform: "translate(-139.6 -197.416)",
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M99.15,184.53l-3.822-2.221,3.28-1.894,3.822,2.221Z",
    transform: "translate(-88.673 -167.82)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M99.221,234.723,95.4,232.5l-.071-24.956,3.822,2.221Z",
    transform: "translate(-88.674 -193.058)",
    fill: "#ff8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M3.823,290.2,0,287.983v-.169l3.822,2.221Z",
    transform: "translate(0 -267.722)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M21.183,0,6.807,8.3A15.026,15.026,0,0,0,0,20.092l3.822,2.221a15.026,15.026,0,0,1,6.807-11.792L25,2.221Z",
    transform: "translate(0)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M75.932,31.817l.011,3.978-14.375,8.3a7.411,7.411,0,0,0-3.356,5.815v.169l-3.462,2v-.169a15.026,15.026,0,0,1,6.807-11.792Z",
    transform: "translate(-50.928 -29.596)",
    fill: "#ff7300"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsMIcon3);
export default __webpack_public_path__ + "static/media/maths-m-icon-3.f730a574c1a05c9b882faf5e84fcc239.svg";
export { ForwardRef as ReactComponent };